// extracted by mini-css-extract-plugin
export default {"container":"oVAmpCN99ojqToMesD3r","heading":"UJbYhQuN6vn1zzPhSlNk","templates":"m3Z7FwyXDq4YGN0eIP3Q","tags":"X3nazN7SdzDZKg0CIVHx","tag":"m3YYre7KFdFcim0u9iIN"};